import * as React from 'react';
import { Popover } from 'antd';
import { EyeOutlined } from '@ant-design/icons';

interface InternalOnlyChipProps {
	/** Spacing from the caller — this chip sits inline in layouts that space it differently. */
	className?: string;
}

/**
 * Marks an attachment that clients never see. Shared by the notes timeline's attachment log entries
 * and the Files list in the Media, Files & Links view, so an internal file is labelled the same way
 * wherever it surfaces.
 */
export const InternalOnlyChip: React.FC<InternalOnlyChipProps> = ({ className = '' }) => (
	<Popover content="This attachment is hidden from clients and only visible to your team">
		<div
			className={`bodymedium inline-flex items-center gap-1 rounded-full bg-gray-200 px-2.5 py-1 text-gray-700 ${className}`}
		>
			<div>
				<EyeOutlined />
			</div>
			<div>Internal Only</div>
		</div>
	</Popover>
);

export default InternalOnlyChip;
